<template>
    <v-flex xs12 class="network_banner">
        <v-layout row wrap>
        <v-flex xs12 sm8>
        <Breadcrumb></Breadcrumb>
        <v-flex class="community_title" v-if="isVisible">
            <v-flex class="community_title__name" data-qe-id="NetworkBanner_CommunityName">{{communityName}}</v-flex>
            <v-flex class="community_title__chapter" data-qe-id="SubNetworkBanner_CommunityName" v-if="isSubNetwork">{{subNetworkOf}}</v-flex>
        </v-flex>
        </v-flex>
        <v-flex xs12 sm4 class="banner_view__options" v-if="isVisible">
            <admin-view-option v-if="isCommunityAdmin">
            </admin-view-option>
            <manage-community-options class="more-actions"
                v-if="!isAllNetworks"
                :displayInviteSomeone="isExistNetwork && currentCommunityView !== userRoles.ADMIN"
                :displayJoin="!isExistNetwork && hasCommunityIdInRoute"
                :isEligibleToJoin="isEligibleToJoin"
                :displayResign="isExistNetwork && currentCommunityView !== userRoles.ADMIN"
                :communityCategory="communityCategory"
                :enrollmentType="enrollmentType"></manage-community-options>
        </v-flex>
        </v-layout>

    </v-flex>
</template>

<script>
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { userRoles } from "../appCommon.constants";
    import ManageCommunityOptions from '../ManageCommunityOptions/ManageCommunityOptions';
    import AdminViewOption from '../AdminViewOption/AdminViewOption';
    import Breadcrumb from "../Layout/Breadcrumb";
    import { myToolsConstants } from "../Tools/mytools.constant";

    export default {
        name: 'NetworkBanner',
        components: {
            ManageCommunityOptions,
            AdminViewOption,
            Breadcrumb,
        },
        data: () => ({
            userRoles,
            Breadcrumb,
        }),
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                currentCommunityView: `${[storeGetters.currentCommunityView]}`,
                ypoNetworks: `network/${storeGetters.ypoNetworks}`,
                subNetworkList: `network/${storeGetters.subNetworkList}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            }),
            isAllNetworks() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE);
            },
            communityType() {
                return this.$route.name;
            },
            communityCategory() {
                if (this.communityInfo) {
                    return this.communityInfo.category;
                }
            },
            enrollmentType() {
                if (this.communityInfo) {
                    return this.communityInfo.enrollmentMethod;
                }
            },
            communityName() {
                if (this.communityInfo) {
                    return this.communityInfo.name;
                }
            },
            isEligibleToJoin() {
                if (this.communityInfo && this.communityInfo.category) {
                    return this.communityInfo.isEligibleToJoin;
                }
            },
            isExistNetwork() {
                return this.usersCommunitiesList && this.usersCommunitiesList.length > 0 && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId);
            },
            hasCommunityIdInRoute() {
                return !!this.$route.params.communityId;
            },
            isSubNetwork() {
                //!checking if current item exists in YpoNetworks if not that will be a subnetwork
                return this.communityInfo && this.communityInfo.isSubCommunity;
            },
            getParentNetwork() {
                if (this.ypoNetworks && this.isSubNetwork && this.communityInfo) {
                    return this.ypoNetworks.find(o => o.communityId === this.communityInfo.parentId);
                }
            },
            isVisible() {
                return this.$route.params.communityId !== undefined;
            },
            subNetworkOf() {
                if (this.ypoNetworks && this.isSubNetwork && this.getParentNetwork) {
                    return `A Sub-Network of the ${this.getParentNetwork.name}`;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .network_banner {
        background: url(../../assets/ypo-banner.jpg);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 64px;

        @include breakpoint(xs) {
            margin-top: 125px !important;
        }

        &:before {
            content: '';
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .awards_block {
            position: absolute;
            right: 29px;
            top: 20px;
            z-index: 1;
            text-align: right;
            font-size: 12px;
            color: $white;
            font-family: 'Raleway', sans-serif;

            span {
                float: left;
                padding-top: 12px;
                font-size: 10px;
            }

            strong {
                display: block;
                font-size: 14px;
                font-weight: 500;
            }

            img {
                max-width: 28px;
                float: right;
                margin-left: 3px;
            }
        }


    }
</style>
